import React from 'react';

/**
 * ErrorBoundary — catches unhandled render errors in child component trees
 * and shows a graceful fallback instead of crashing the whole app.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // In production you could send this to an error tracking service
    console.error('[ErrorBoundary] Caught error:', error, info.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const label = this.props.label || 'This section';

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.75rem',
        minHeight: '240px',
        padding: '2rem',
        color: '#888',
        textAlign: 'center',
      }}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
          stroke="#ddd" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        <div>
          <p style={{ margin: '0 0 0.25rem', fontWeight: 600, color: '#555' }}>
            {label} encountered an error
          </p>
          <p style={{ margin: 0, fontSize: '0.82rem', maxWidth: 300 }}>
            Something went wrong rendering this view. Your data is safe.
          </p>
        </div>
        <button
          onClick={this.handleReset}
          style={{
            padding: '0.5rem 1.25rem',
            background: '#111',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '0.85rem',
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
